import { useState, useEffect } from "react";

import Switch from '@mui/material/Switch';

const SwitchInput = (props) => {
  const { id, type, typeName, order, input: { onChange }, options, required } = props;
  const [checked, setChecked] = useState(false);

  // FYI: If required MUST have default any value(true or false), must have 2 attributes: true, false
  //  One of them MUST be set default: true

  useEffect(() => {
    // console.log('options', options);
    if (options?.length > 0) {
      for (let i = 0; i < options.length; i++) {
        if (options[i].default) {
          changeHandler(options[i]?.value);
        }
      }
    }
  }, []);

  const changeHandler = (checked) => {
    setChecked(checked);

    // if required and result is false then deleted from redux store
    // next questions will be hidden
    // For required switch means check TRUE, not just only NOT empty result value, it holds only true or nothing
    // For non required switch result value in redux store always will hold a value true/false
    // if (!checked && required) {
    //   return onChange(null);
    // }
    // INFO: No need to check if required since the survey FLOW may be configured in nextQuestion as branch for TRUE, and now branch for FALSE and vice versa

    return onChange(
      {
        id,
        typeName,
        order,
        result: checked
      }
    );
  }

  return (
    <Switch
      checked={checked}
      onChange={(event) => changeHandler(event?.target?.checked)}
    />
  );
}

export default SwitchInput;